export enum CalculationStepsEnum {
  INFO,
  FLAT_RATES,
  EXTRACTED_CODE,
  ADDITIONAL_CODE,
  WORKSITE,
}
